import { render, staticRenderFns } from "./facet.vue?vue&type=template&id=4ea83d93&"
import script from "./facet.vue?vue&type=script&lang=ts&"
export * from "./facet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports